import {
  GET_ENTITY_REPORT_OPTIONS,
  GET_ENTITY_REPORT_OPTIONS_ERROR,
  GET_ENTITY_REPORT_OPTIONS_SUCCESS
} from './DownloadFrameworkSection.actions'

const initialState = {
  biddingOptions: [],
  loading: false,
  error: null
}

/**
 * DownloadFrameworkReducer's reducer.
 */
const DownloadFrameworkReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_ENTITY_REPORT_OPTIONS: {
      return { ...state, loading: true }
    }
    case GET_ENTITY_REPORT_OPTIONS_SUCCESS: {
      return { ...state, biddingOptions: payload.biddingOptions, loading: false }
    }
    case GET_ENTITY_REPORT_OPTIONS_ERROR: {
      return { ...state, error: payload.error }
    }
    default: {
      return state
    }
  }
}

export default DownloadFrameworkReducer
